import { createSelector } from "reselect"
import { get, find } from "lodash"
import { CATEGORIES, CONCENTRATION_FACTORS } from "helpers/analyzeConstants"
import { getBetaColumnsAndTooltips } from "helpers/tables"
import { getPortfolioBetaInstrument } from "modules/portfolio-root/selectors/beta-instrument"
import { getSelectedModelName } from "modules/portfolio-root/selectors/portfolios"

export const getDisabled = state => get(state, "modules.analyzeComposition.disabled")
export const getRawDisplayType = state => get(state, "modules.analyzeComposition.displayType")

export const getDisplayType = createSelector(
  [getRawDisplayType],
  (displayType) => {
    if (find(CATEGORIES, cat => cat.id === displayType)) {
      return displayType
    }

    return CATEGORIES[0].id
  },
)

export const getDisplayTypeName = createSelector(
  [getRawDisplayType],
  (displayType) => {
    const category = find(CATEGORIES, cat => cat.id === displayType)
    if (category) {
      return category.label
    }

    return CATEGORIES[0].label
  },
)

const getBetaFactors = createSelector(
  [getSelectedModelName, getPortfolioBetaInstrument],
  getBetaColumnsAndTooltips,
)

export const getFactors = createSelector(
  [getRawDisplayType, getBetaFactors],
  (displayType, betaFactors) => displayType === "beta" ? betaFactors : CONCENTRATION_FACTORS,
)
